module.exports = __webpack_public_path__ + "investor-education-static-manager/img/no-list-data-icon.72bfa2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-list-data-icon.png
// module id = BnID
// module chunks = 42